import { render, staticRenderFns } from "./teacher-classes-list.vue?vue&type=template&id=5f22d184&scoped=true&"
import script from "./teacher-classes-list.ts?vue&type=script&lang=ts&"
export * from "./teacher-classes-list.ts?vue&type=script&lang=ts&"
import style0 from "./teacher-classes-list.scss?vue&type=style&index=0&id=5f22d184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f22d184",
  null
  
)

export default component.exports